import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import clsx from 'clsx'

import { makeStyles, useTheme } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { isEmpty } from 'lodash'
import { useCookies } from 'react-cookie'

import AccountMenu from './AccountMenu'
import { ReactComponent as LogoRipley } from '../../assets/svg/logoRipley.svg'
import { useSession } from '../../contexts/SessionContext'

const drawerWidth = 240
const shoppingWidth = 500

const useStyles = makeStyles(theme => ({
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  root: {
    display: 'flex',
  },
  toolBar: {
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  navbarLeftContainter: {
    // marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  appBar: {
    height: 70,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: theme.palette.common.white,
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(1.5),
    marginLeft: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
  },
  hide: {
    display: 'none',
  },
  logoImg: {
    height: 40,
    marginRight: theme.spacing(0.5),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerMenuPaper: {
    width: drawerWidth,
  },
  drawerShoppingPaper: {
    width: shoppingWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  textHeaderShopping: {
    marginRight: 'auto',
    paddingLeft: theme.spacing(2),
    fontWeight: 600,
  },
  searchContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  searchInput: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}))

const Header = () => {
  // const location = useLocation()
  const classes = useStyles()
  const { sessionData } = useSession()
  const [cookies] = useCookies(['statusCookie'])
  const history = useHistory()

  const theme = useTheme()
  const [openMenu, setOpenMenu] = useState(false)

  function handleMenuOpen() {
    setOpenMenu(true)
  }

  function handleMenuClose() {
    setOpenMenu(false)
  }

  return !isEmpty(sessionData) || cookies.statusCookie === '200' ? (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        elevation={1}
        className={clsx(classes.appBar, {
          [classes.appBarShift]: openMenu,
        })}
      >
        <Toolbar className={classes.toolBar}>
          <IconButton
            color="default"
            aria-label="Open drawer"
            onClick={handleMenuOpen}
            edge="start"
            className={clsx(classes.menuButton, openMenu && classes.hide)}
          >
            <MenuIcon />
          </IconButton>

          <IconButton
            onClick={() => {
              history.push('/')
            }}
          >
            <LogoRipley />
          </IconButton>

          <div className={classes.navbarLeftContainter}>
            <AccountMenu classes={classes.menuButton} />
          </div>
        </Toolbar>
      </AppBar>

      {/* Menu Drawer */}

      <Drawer
        className={classes.drawer}
        anchor="left"
        open={openMenu}
        classes={{
          paper: classes.drawerMenuPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleMenuClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          <ListItem button onClick={() => history.push('/buscar')}>
            <ListItemText>Buscar</ListItemText>
          </ListItem>
          <ListItem button onClick={() => history.push('/')}>
            <ListItemText>Cerrar sesión</ListItemText>
          </ListItem>
        </List>
      </Drawer>
    </div>
  ) : null
}

// Header.propTypes = {
//   path: PropTypes.string,
// }

// Header.defaultProps = {
//   path: ``,
// }

export default Header
